import { Injectable } from '@angular/core';

const RESET_STYLE = `
/* Style harmonisé pour aperçu - uniquement font-family et styles structurels */
body {
  font-family: Arial, Helvetica, sans-serif;
  /* PAS de line-height ni font-size - doivent venir de Froala */
}

table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}

.ql-editor {
  padding: 0 !important;
}

/* Marges à 0 pour cohérence - font-size et line-height viennent de Froala */
.content h6, .content h5, .content h4,
.content h3, .content h2, .content h1,
.content p {
  margin: 0 !important;
}

.content .ql-align-center { text-align: center !important; }
.content .ql-align-right { text-align: right !important; }
.content .ql-align-left { text-align: left !important; }

.content {
  margin-top: 20px;
  height: auto;
  display: block;
}
`;

@Injectable({
  providedIn: 'root'
})
export class QuillUtilsService {

  public static resetStyle = RESET_STYLE;

  constructor() { }

  public static setQuillPreviewStyle(style: string): string {
    return style;
  }
}
